export function snapshotExists(snapshot) {
  if (!snapshot || snapshot.exists == null) {
    return false;
  }

  return typeof snapshot.exists === 'function' ? snapshot.exists() : Boolean(snapshot.exists);
}
